// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Cn          = require("re-classnames/lib/js/src/Cn.bs.js");
var React       = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./WinModal.css')));

var component = ReasonReact.statelessComponent("Card");

function make($staropt$star, onPlayAgain, _) {
  var isOpen = $staropt$star ? $staropt$star[0] : /* false */0;
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: Cn.make(/* :: */[
                        "WinModal",
                        /* :: */[
                          "modal",
                          /* :: */[
                            Cn.ifBool(isOpen, "is-active"),
                            /* [] */0
                          ]
                        ]
                      ])
                }, React.createElement("div", {
                      className: "modal-background"
                    }), React.createElement("div", {
                      className: "modal-content"
                    }, React.createElement("div", {
                          className: "card"
                        }, React.createElement("div", {
                              className: "card-content"
                            }, React.createElement("p", {
                                  className: "title"
                                }, "Congratulations, you win!"), React.createElement("img", {
                                  src: "https://media.giphy.com/media/9WqOLBW3KIBOM/giphy.gif"
                                })), React.createElement("footer", {
                              className: "card-footer"
                            }, React.createElement("p", {
                                  className: "card-footer-item",
                                  onClick: onPlayAgain
                                }, React.createElement("span", undefined, "Play again"))))));
    });
  return newrecord;
}

exports.component = component;
exports.make      = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/WinModal.re
// module id = 52
// module chunks = 0